import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export function SendToSelectedDialog({ slot, leadIds, onDone }) {
  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [tid, setTid] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get(`/projects/${slot}/templates`).then((r) => setTemplates(r.data));
    setName(`Utskick ${new Date().toLocaleDateString("sv-SE")} (${leadIds.length} leads)`);
  }, [open, slot, leadIds.length]);

  const send = async () => {
    if (!window.confirm(`Skicka mallen till ${leadIds.length} markerade lead(s) nu?`)) return;
    setBusy(true);
    try {
      await api.post(`/projects/${slot}/campaigns`, { name, template_id: tid, audience: "selected", lead_ids: leadIds });
      toast.success("Utskick startat", { description: "Följ förloppet under fliken Campaigns." });
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" data-testid="lead-send-template-button"><Send className="h-4 w-4 mr-1.5" />Send template to {leadIds.length}</Button>
      </DialogTrigger>
      <DialogContent className="bg-card">
        <DialogHeader><DialogTitle>Send template to {leadIds.length} marked lead(s)</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label>Template</Label>
            <Select value={tid} onValueChange={setTid}>
              <SelectTrigger data-testid="send-selected-template-select"><SelectValue placeholder="Choose template" /></SelectTrigger>
              <SelectContent>{templates.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
            </Select>
            {templates.length === 0 && <p className="text-xs text-amber-700">Create a template in the Templates tab first.</p>}
          </div>
          <div className="space-y-1.5"><Label>Campaign name</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="send-selected-name-input" /></div>
          <p className="text-xs text-muted-foreground">Unsubscribed, bounced and invalid leads are skipped automatically.</p>
          <Button className="w-full" onClick={send} disabled={busy || !tid || !name} data-testid="send-selected-confirm-button">
            <Send className="h-4 w-4 mr-2" />{busy ? "Sending…" : "Send now"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
